<template>
  <div class="marketing-options">
    <checkbox-square
      :name="`${type}-marketing-all`"
      class="direct-marketing__all mr-4"
      :data-test="`${type}_marketing_all`"
      :checked="checkAllValue"
      @change="changeOption('all', $event)"
    >
      Accept all
    </checkbox-square>
    <ul class="marketing-items">
      <li
        v-for="option in optionsList"
        :key="option"
      >
        <checkbox
          :data-test="`${type}_marketing_${snakeCase(option)}`"
          :checked="optionsValue[getFieldName(option)]"
          @change="changeOption(getFieldName(option), $event)"
        >
          {{ getOptionLabel(option) }}
        </checkbox>
      </li>
    </ul>
  </div>
</template>

<script>
import { capitalize, snakeCase } from 'lodash';

export default {
  name: 'marketing-options',
  inject: ['constants', 'config'],
  props: {
    type: {
      type: String,
      required: true,
    },
    optionsValue: {
      type: Object,
      required: true,
    },
    optionsList: {
      type: Array,
      required: true,
    },
    checkAllValue: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getFieldName (option) {
      return `${this.type}Marketing${this.capitalize(option)}`;
    },
    getOptionLabel (option) {
      const key = `${this.type.toUpperCase()}_MARKETING_OPTIONS`;
      return this.constants[key][option].label;
    },
    changeOption (option, value) {
      this.$emit('change-option', { option, value });
    },
  },
  setup () {
    return {
      snakeCase,
      capitalize,
    };
  },
};
</script>

<style lang="scss" scoped>
.marketing-options {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  .marketing-items {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;

    & > * {
      margin: 5px 20px 5px 0;
    }

    & > *:last-child {
      margin-right: 0 !important;
    }

    li {
      margin-top: 5px;

      @media screen and (max-width: 767px) {
        margin-left: 0;
      }
    }
  }
}
</style>
